module.exports = __webpack_public_path__ + "assets/ic-wchat.ccb63f9b.svg";